import { IconButton, styled } from '@mui/material';

export const CrumbLink = styled('span')`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.p080};
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;

export const CrumbSeparator = styled('span')`
  color: ${({ theme }) => theme.palette.primary.p040};
  font-weight: 400;
  margin: 0 2px;
`;

export const EllipsisBtn = styled(IconButton)`
  padding: 2px 4px;
  border-radius: 4px;
  vertical-align: middle;
  margin: 0 2px;
`;

export const BreadcrumbInner = styled('span')`
  direction: ltr;
  unicode-bidi: bidi-override;
`;
